export const API_TOKEN_STORAGE_KEY = 'token';
export const API_TOKEN_STORAGE_EXPIRES_AT = 'token_expires_at';
export const USER_STORAGE_KEY = 'user';
